import React from 'react';
import { BiomeIcon, IconName } from '@codametrix/verdigris';
import { Tooltip } from '@chakra-ui/react';
import './styles/index.scss';
type InvoiceMetaProps = {
  meta: CMxArtifacts.ArtifactMetaData;
  onImportClick?: (ev: React.MouseEvent) => void;
};

const squelch = (ev: React.MouseEvent) => ev.preventDefault();

export const InvoiceMetaHeading: React.FC<InvoiceMetaProps> = ({
  meta,
  onImportClick
}) => {
  if (meta.imported) {
    return (
      <div className="import-divider qa-invoice-meta invoice-meta-container">
        <h4 className="meta-heading-label">
          Bundled codes{' '}
          <Tooltip label="This case was billed under the following case.  The diagnosis may or may not apply directly.">
            <span>
              <BiomeIcon
                iconName={IconName.Info}
                iconSize="16"
                iconClass="icon-image"
                titleText="Info"
              />
            </span>
          </Tooltip>
        </h4>
        <InvoiceMeta meta={meta} onImportClick={onImportClick} />
      </div>
    );
  }
  return (
    <div className="import-divider qa-invoice-meta invoice-meta-container">
      <h4 className="meta-heading-label">
        Original codes{' '}
        <Tooltip label="This case was billed as the case shown above.  The codes below are original to this case, but may or may not have been used in billing.">
          <span>
            <BiomeIcon
              iconName={IconName.Info}
              iconSize="16"
              iconClass="icon-image"
              titleText="Info"
            />
          </span>
        </Tooltip>
      </h4>
    </div>
  );
};

export const InvoiceMeta: React.FC<InvoiceMetaProps> = ({
  meta,
  onImportClick
}) => {
  if (meta.imported) {
    return (
      <span className="submitted-item-link-container">
        Sent as{' '}
        <a
          className="qa-related-group-item-link submitted-item-link"
          href={`/cmx/cases/${meta.ownerCaseId}`}
          onClick={onImportClick}
          data-case-id={`${meta.ownerCaseId}`}>
          <div className="view-case-link-inner sensitive-data">
            {meta.description}
          </div>
        </a>
      </span>
    );
  }

  return <span className="invoice-meta-empty"></span>;
};
